import Vue from "vue"
import Vuetify from "vuetify"
import "@mdi/font/css/materialdesignicons.css"

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        // MAIN
        primary: "#16A085",
        secondary: "#E9ECEF",
        accent: "#493D55",
        error: "#e05d6f",
        warning: "#f0ad4e",
        info: "#5bc0de",
        success: "#5cb85c",
      },
      dark: {
        // MAIN
        primary: "#16A085",
        secondary: "#E9ECEF",
        accent: "#493D55",
        error: "#e05d6f",
        warning: "#f0ad4e",
        info: "#5bc0de",
        success: "#5cb85c",
      },
    },
    options: {
      customProperties: true,
    },
  },
})
